import React from 'react'
import FollowUpListPresenter from './FollowUpListPresenter'
import { dialog, Button } from '../../../nq-component'
import {
  addSchemaUseCase,
  updateSchemaUseCase,
  deleteSchemaUseCase,
} from '../../../usecases/schema/usecases'
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from '../../../usecases/object'
import { exportCSVUseCase } from '../../../usecases/csv/usecases'
import { Progress, InfiniteScroll } from '../../../nq-component'
import withRouter from '../../../withRouter'
import Search from '../components/Search'
import BaseListPage from '../../../base/BaseListPage'
import NavBar from '../../../components/navbar'
import InputFactory from '../../../components/InputFactory'
import Table from '../../../components/Table'


class FollowUpListPage extends BaseListPage {
  constructor(props) {
    super(props)
    this.presenter = new FollowUpListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      exportCSVUseCase(),
      addSchemaUseCase(),
      updateSchemaUseCase(),
      deleteSchemaUseCase(),
      this.props.params.id
    )
  }

  /*when class change*/
  componentDidUpdate(prevProps, prevState) {
    this.presenter.componentDidUpdate(prevProps, prevState)
  }

  getCollectionName() {
    return "followUp";
  }

  closeDialog() {
    dialog.close()
  }

  onClickAdd() {
    const inquiryId = this.props.params.id
    this.navigateTo(`/inquiries/quotation/follow-up/${inquiryId}/new`)
  }

  onClickView(index) {
    const object = this.state.objects[index];
    const inquiryId = this.props.params.id
    this.navigateTo(`/inquiries/quotation/follow-up/${inquiryId}/view/${object?.id}`)
  }

  onClickBack() {
    this.navigateTo("/inquiries"); 
  }  

  onChangeFilter(type, value, field) {
    const where = {}
    switch (type) {
      case 'Pointer':
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id }
        }
        break
      case 'Boolean':
        where[field] = value
        break
      default:
        where[field] = { $regex: value, $options: 'i' }
    }
    this.searchSubmit(where)
  }

  // viewApplication(index) {
  //   const object = this.presenter.objects[index]
  //   const collection = this.view.getCollectionName()
  //   this.view.navigateTo('/collection/' + collection + '/form/' + object.id)
  // }

  acceptApplication(index, field) {
    this.presenter.acceptApplication(index, field)
  }

  onCollapse(index) {
    const data = this.state.objects[index];
    const formattedDate = data?.date
      ? new Date(data.date).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
      : 'N/A'
    return (
      <div className='p-1 text-start'>
        <div><strong>Title:</strong> {data?.title}</div>
        <div><strong>Date Submitted:</strong> {formattedDate}</div>
        
        <div className="mt-2 d-flex align-items-center gap-2">
          <button
            className="btn btn-primary text-black"
            onClick={() => this.onClickView(index)}
          >
            <i className="bi bi-eye" /> View
          </button>
        </div>
      </div>
    );
  }  

  render() {
    const schema = this.getSchema(this.getCollectionName())
    const { objects, count, progress } = this.state
    if (!schema) return <Progress />
    const user = this.getCurrentUser()
    return (
      <>
        <NavBar 
          action={() => {
            if(!user.isMaster) return null
            return (
              <div className='dropdown dropstart d-inline-block'>
                <i
                  data-bs-toggle='dropdown'
                  className='bi bi-three-dots=vertical text-primary'
                ></i>
              </div>
            )
          }}/>
        <div className='overflow-auto'>
          <InfiniteScroll
            className='h-100'
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className='p-3 p-lg-4'>
            <div className="d-flex align-items-start mt-3">
            <i className="bi bi-chevron-left" style={{ fontSize: '1.5rem' }} onClick={this.onClickBack.bind(this)}></i>
                <h1 className='fw-bold text-capitalize'>
                  Follow Up
                </h1>
              </div>
              <div className='d-flex mt-3'>
                {Object.keys(schema.filters || {}).map((field) => {
                  let { type, ...options } = schema.filters[field]
                  return (
                    <InputFactory
                      key={field}
                      className='ms-1'
                      type={type}
                      field={field}
                      where={{}}
                      onChange={this.onChangeFilter.bind(this, type)}
                      {...options}
                    />
                  )
                })}
              </div>
              <Search
                schemas={this.getSchemas()}
                className='mt-3'
                onSubmit={this.searchSubmit.bind(this)}
                fields={schema.fields}
              />
              <Table
                fields={schema.fields}
                objects={objects}
                collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key]
                    if (options.read === false) {
                      acc.push(key)
                    }
                    switch (options._type || options.type) {
                      case 'Relation':
                      case 'Array':
                      case 'Object':
                      case 'File':
                        acc.push(key)
                        break
                      default:
                    }
                    return acc
                  },
                  ['acl', 'password', 'client', 'subject', 'body']
                )}
                progress={progress}
                onClickItem={this.onClickItem.bind(this)}
                className='mt-3 rounded text-center'
                onCollapse={this.onCollapse.bind(this)}           
              />
            </div>
          </InfiniteScroll>
        </div>
        <div className='position-fixed bottom-0 end-0 m-4'>
          <Button
            className='btn btn-primary shadow-sm bg-primary'
            onClick={this.onClickAdd.bind(this)}
            style={{ width: '50px', height: '50px', borderRadius: '25px' }}
          >
            <i className='bi bi-plus-lg' />
          </Button>
        </div>
      </>
    )
  }
}

export default withRouter(FollowUpListPage)